"use strict";

exports.__esModule = true;
exports.defaultProps = void 0;
// eslint-disable-next-line import/prefer-default-export
var defaultProps = {
  data: {
    api_key: 'AIzaSyD9kzc2h_MwSqZaI7xBEt0VyxWI3kUlQs4',
    resourceType: 'MiniDealerLocator_1_0_0',
    title: 'Appointment Preferences',
    subHeadline: 'Pick a dealership',
    searchFieldLabel: 'Address',
    searchHelpText: 'Enter Postcode or Location',
    locationCtaLabel: 'Use Current Location',
    viewMoreText: 'View More',
    preSelectedFilter: 'sales',
    noDealershipFoundMessage: "We couldn't find any dealerships near you. Please try a different location.",
    noGeolocationMessage: 'We encountered an error while locating you. Please try again later.',
    radius: 2000,
    metricSystem: 'imperial',
    showRating: true,
    enableTheSearchPostcode: true
  },
  skipServerRendering: false
};
exports.defaultProps = defaultProps;